import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router';
import CustomBtn from '../../../../../../generic/CustomBtn';
import './DetermineZone.scss';
import { REGISTER_STATUS } from '../../../../../../constans/constans';

const DetermineZone = ({ projectStatus }) => {
  const translate = useIntl();
  const history = useHistory();
  const { nameId } = useParams();
  const [startProject] = useState(projectStatus === REGISTER_STATUS);

  return (
    <div className="determineZone">
      <p className="determineZone-message">
        {translate.formatMessage(startProject
          ? { id: 'monitoringData.modal.description-start' }
          : { id: 'monitoringData.modal.description' })}
      </p>
      <CustomBtn
        label={translate.formatMessage(startProject
          ? { id: 'projectCard.start' }
          : { id: 'monitoringData.modal.button-submit' })}
        type="button"
        handleClick={() => history.push(`/data-upload/${nameId}`)}
        customClass="determineZone-btn"
      />
    </div>
  );
};

export default DetermineZone;
